module.exports = __webpack_public_path__ + "img/pangpang.db4c9685.png";